import * as React from 'react';
import {
  Create,
  SimpleForm,
} from 'react-admin';
import ScientificLiteratureKeywordForm from './ScientificLiteratureKeywordForm';
import FormToolbar from '../shared/FormToolbar';

const ScientificLiteratureKeywordEdit = props => (
  <Create {...props}>
    <SimpleForm
      toolbar={<FormToolbar />}
      redirect="list"
    >
      <ScientificLiteratureKeywordForm {...props} />
    </SimpleForm>
  </Create>
);

export default ScientificLiteratureKeywordEdit;
